import validateChangePasswordForm from './forms/changepassword';
import validatePasswordRecoveryForm from './forms/passwordrecovery';

validatePasswordRecoveryForm('#recover-password');
validateChangePasswordForm('#change-password');
validateChangePasswordForm('#force-recovery-password');
